import { Avatar, Card, Font, Icon, Tag, TextInput, Toggle } from "pepsico-ds";
import useModalState from "../../../hooks/useModalState";
import Modal from "./Modal";
import "./socialMediaSelector.scss";

export default function MediaCard({
  socialMedia,
  handleSocialMediaUpdate,
  id,
  readOnly,
  inlineEdit = false,
}) {
  const [isOpen, onOpen, onClose] = useModalState();
  const showInlineEditor = inlineEdit && !readOnly;

  const updateSocialMedia = (property, value) => {
    handleSocialMediaUpdate(id, {
      ...socialMedia,
      [property]: value,
    });
  };

  return (
    <section
      className={`social-media-card${
        showInlineEditor ? " social-media-card--inline-edit" : ""
      }`}
    >
      <Card
        border
        ellipsis
        icon="info"
        onEllipsisClick={function Qa() {}}
        onIconClick={function Qa() {}}
        title="Title"
      >
        {showInlineEditor ? (
          <section className="social-media-inline-editor">
            <Icon
              className="drag-icon"
              icon="drag_indicator"
              size="small"
              variant="filled"
            />
            <Avatar
              name={socialMedia?.title}
              imageUrl={socialMedia?.image}
              iconType="business"
              type="image"
              size="small"
            />
            <section className="social-media-inline-fields">
              <section className="social-media-inline-header">
                <Font style={{ color: "#242424", fontWeight: "bold" }}>
                  {`Edit for ${socialMedia?.title}`}
                </Font>
                <section className="social-media-active-control">
                  <span>Active</span>
                  <Toggle
                    checked={Boolean(socialMedia?.active)}
                    label=""
                    onUpdate={(value) => updateSocialMedia("active", value)}
                    size="small"
                    value={socialMedia?.active ? "Yes" : "No"}
                  />
                </section>
              </section>
              <TextInput
                label="URL"
                maxLength={255}
                onUpdate={(value) => updateSocialMedia("url", value)}
                type="url"
                value={socialMedia?.url || ""}
              />
            </section>
          </section>
        ) : (
          <section className="info-container">
            {!readOnly ? (
              <Icon
                className="drag-icon"
                icon="drag_indicator"
                size="small"
                variant="filled"
              />
            ) : null}
            <Avatar
              name={socialMedia?.title}
              imageUrl={socialMedia?.image}
              iconType="business"
              type="image"
              size="small"
            />
            <section className="info-text">
              <section className="info-title">
                <Font style={{ color: "#4C5358", fontWeight: "bold" }}>
                  {socialMedia?.title}
                </Font>
                <Tag
                  color={socialMedia?.active ? "Green-600" : "Gray-100"}
                  size="large"
                  text={socialMedia?.active ? "Active" : "Inactive"}
                  type="filled"
                  isCopyable={false}
                />
              </section>
              <Font style={{ color: "#616161" }}>{socialMedia?.url}</Font>
            </section>
          </section>
        )}
        {!readOnly && !showInlineEditor ? (
          <Icon
            icon="edit"
            label="open edit media modal"
            onClick={onOpen}
            size="medium"
            className="settings-button"
          />
        ) : null}
      </Card>
      {isOpen && !showInlineEditor ? (
        <Modal
          isOpen={isOpen}
          closeModal={onClose}
          socialMedia={socialMedia}
          handleSocialMediaUpdate={handleSocialMediaUpdate}
          id={id}
        />
      ) : null}
    </section>
  );
}
